import { React, useState, useEffect, useMemo } from "react";
import { Typography, Box } from "@mui/material";
import RDataGrid from "../reusables/RDataGrid";
import PageLoader from "../loader/PageLoader";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import AddPopup from "../popup/AddPopup";
import Add from "@mui/icons-material/Add";
import Button from "@mui/joy/Button";
import Notification from "../popup/Notification";
import ConfirmDialog from "../dialog/ConfirmDialog";
import AddSupplier from "../forms/AddSupplier";

const Roles = () => {
  const [isFetchingSuppliers, setIsFetchingSuppliers] = useState(true);
  const [editSupplier, setEditSupplier] = useState(false);
  const [viewSupplier, setViewSupplier] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [refreshSuppliers, setSetRefreshSuppliers] = useState(null);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const [suppliers, setSuppliers] = useState([]);
  const ROLES_URL = "api/v1/roles";
  const axiosPrivate = useAxiosPrivate();

  const divStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  useEffect(() => {
    if (!isFetchingSuppliers) {
      setIsFetchingSuppliers(true);
    }

    let isMounted = true;
    const controller = new AbortController();

    const getRoles = async () => {
      try {
        //const response = await axiosPrivate.get(BAG_URL, {
        const response = await axiosPrivate.get(
          ROLES_URL,
          {
            signal: controller.signal,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        isMounted && setSuppliers(response.data.data);
        setIsFetchingSuppliers(false);
      } catch (error) {
        var errorMessage = "";
        if (error.response) {
          // The client was given an error response (5xx, 4xx)
          const errorData = error.response.data;
          errorMessage = errorData.message;
        } else if (error.request) {
          // The client never received a response, and the request was never left
          errorMessage = "No server response";
        } else {
          // Anything else
          errorMessage = "Unexpected error occurred";
        }
        console.log(errorMessage);
        setIsFetchingSuppliers(false);
      }
    };

    getRoles();

    return () => {
      isMounted = false;
      controller.abort();
    };

    /* eslint-disable react-hooks/exhaustive-deps */
  }, [refreshSuppliers]);

  const columns = useMemo(
    () => [
      {
        field: "rowNo", // from DataGrid rows defifnition
        headerName: "No.",
        sortable: false,
        headerClassName: "super-app-theme--header",
        minWidth: 87,
        flex: 1,
        align: "left",
        headerAlign: "left",
        editable: false,
      },
      /* {
        sortable: true,
        field: "lineNo",
        headerName: "#",
        flex: 0,
        editable: false,
        renderCell: (params) =>
          params.api.getAllRowIds().indexOf(params.id) + 1,
      },
      {
        field: "index",
        headerName: "#h",
        filterable: false,
        disableColumnMenu: true,
        valueGetter: (_, row, __, apiRef) => {
          return apiRef.current.getRowIndexRelativeToVisibleRows(row.id) + 1;
        },
      }, */
      {
        field: "name",
        headerName: "Name",
        headerClassName: "super-app-theme--header",
        minWidth: 160,
        flex: 1,
        align: "left",
        headerAlign: "left",
        editable: false,
      },
    ],
    []
  );

  // Close dialog upon successful supplier add/update
  const closeDialog = (message) => {
    setOpenPopup(false);
    setNotify({
      isOpen: true,
      message: message,
      type: "success",
    });
    setSetRefreshSuppliers(new Date());
  };

  return isFetchingSuppliers ? (
    <PageLoader title="Loading roles..." />
  ) : (
    <Box
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      {suppliers?.length ? (
        <Box
          sx={{
            height: "100%",
            width: "100%",
          }}
        >
          <div style={divStyle}>
            <Typography
              sx={{
                textAlign: "left",
                mt: 3,
                mb: 3,
                fontSize: {
                  lg: 30,
                  md: 20,
                  sm: 20,
                  xs: 19,
                },
              }}
            >
              Roles
            </Typography>

            {/* <Button
              sx={{
                size: { xs: "xs", sm: "xs", md: "md", lg: "lg", xl: "lg" },
              }}
              variant="solid"
              color="primary"
              onClick={function () {
                setEditSupplier(false);
                setSelectedSupplier(null);
                setOpenPopup(true);
              }}
              startDecorator={<Add />}
            >
              Role
            </Button> */}
          </div>
          <Box
            sx={{
              width: "100%",
              margin: "0 auto 16px",
              height: 560,
              overflow: "hidden",
            }}
          >
            <RDataGrid columns={columns} rows={suppliers} rowHeight={63} />
          </Box>
          <Notification notify={notify} setNotify={setNotify} />
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <AddPopup
            width="md"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            title={
              viewSupplier
                ? "View (Edit) Role"
                : editSupplier
                ? "Edit (View) Role"
                : "Add Role"
            }
          >
            <AddSupplier
              closeDialog={closeDialog}
              editSupplier={editSupplier}
              selectedSupplier={selectedSupplier}
            />
          </AddPopup>
        </Box>
      ) : (
        <div style={divStyle}>
          <Typography
            variant="h4"
            component="h4"
            sx={{ textAlign: "center", mt: 3, mb: 3 }}
          >
            No roles to display
          </Typography>
          <Button
            sx={{
              size: { xs: "xs", sm: "xs", md: "md", lg: "lg", xl: "lg" },
            }}
            variant="solid"
            color="primary"
            onClick={function () {
              setEditSupplier(false);
              setSelectedSupplier(null);
              setOpenPopup(true);
            }}
            startDecorator={<Add />}
          >
            Role
          </Button>
          <Notification notify={notify} setNotify={setNotify} />
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <AddPopup
            width="md"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            title={
              viewSupplier
                ? "View (Edit) Role"
                : editSupplier
                ? "Edit (View) Role"
                : "Add Role"
            }
          >
            <AddSupplier
              closeDialog={closeDialog}
              editSupplier={editSupplier}
              selectedSupplier={selectedSupplier}
            />
          </AddPopup>
        </div>
      )}
    </Box>
  );
};

export default Roles;
